import { axios } from '../utilities';

const updateChapter = (chapterId, chapter) => axios.put(`api/chapters/${chapterId}`, { chapter });

const addCommentToChapter = (
  chapterId,
  commentId,
  comment,
  delta,
) => axios.post(
  `api/chapters/${chapterId}/comments/${commentId}`,
  { comment, delta },
);

const addReplyToCommentInChapter = (
  chapterId,
  commentId,
  replyId,
  reply,
) => axios.post(
  `api/chapters/${chapterId}/comments/${commentId}/replies/${replyId}`,
  { reply },
);

const updateReplyToCommentInChapter = (
  chapterId,
  commentId,
  replyId,
  replyText,
) => axios.put(
  `api/chapters/${chapterId}/comments/${commentId}/replies/${replyId}`,
  { replyText },
);

const updateCommentInChapter = (
  chapterId,
  commentId,
  commentText,
) => axios.put(
  `api/chapters/${chapterId}/comments/${commentId}/update`,
  { commentText },
);

const resolveCommentInChapter = (
  chapterId,
  commentId,
) => axios.put(
  `api/chapters/${chapterId}/comments/${commentId}/resolve`,
);

const deleteCommentInChapter = (
  chapterId,
  commentId,
) => axios.delete(
  `api/chapters/${chapterId}/comments/${commentId}`,
);


const deleteComments = (
  chapterId,
  commentsIds,
) => axios.put(
  `/api/chapters/${chapterId}/comments/delete`,
  { commentsIds },
);

const undoComments = (
  chapterId,
  commentsIds,
) => axios.put(
  `/api/chapters/${chapterId}/comments/undo`,
  { commentsIds },
);

const saveChaptersChanges = (chapters, chaptersToDelete, dedication, bookTitleIdeas, bookId) =>
  axios.post('api/chapters/saveChanges', {
    chapters, chaptersToDelete, dedication, bookTitleIdeas, bookId,
  });

const getProofDataByUserId = (userId) => axios.get(`api/chapters/user/${userId}`);

const getProofDataByProjectId = (projectId) => axios.get(`api/chapters/project/${projectId}`);

const askClaude = (message, projectId, isTranscriptIncluded, tokensMultiplier) =>
  axios.post(`api/chapters/${projectId}/askClaude`, {
    message, isTranscriptIncluded, tokensMultiplier,
  }, { timeout: 0 });

const wrapWithTagsAndSave = (message, projectId) =>
  axios.post(`api/chapters/${projectId}/wrapWithTagsAndSave`, { message }, { timeout: 0 });

const generateClaudeReplyWithTranscript = (message, projectId) =>
  axios.post(`api/chapters/${projectId}/generateClaudeReplyWithTranscript`, { message }, { timeout: 0 });

export default {
  updateChapter,
  addCommentToChapter,
  addReplyToCommentInChapter,
  updateCommentInChapter,
  updateReplyToCommentInChapter,
  resolveCommentInChapter,
  deleteCommentInChapter,
  deleteComments,
  undoComments,
  saveChaptersChanges,
  getProofDataByUserId,
  getProofDataByProjectId,
  askClaude,
  wrapWithTagsAndSave,
  generateClaudeReplyWithTranscript,
};
